import React from 'react';
import BibliothequePlotly from '../../../Graphe/AffichageGraphe/BibliothequePlotly/BibliothequePlotly';

const ProgresseBar = ({ value, ratio, units, viewobj_json_content }) => {
  const data = [
    {
      value: value,
      type: 'indicator',
      mode: 'gauge+number',
      title: {
        text: 'Progression',
        align: 'left',
        size: 54 * ratio,
      },
      number: {
        prefix:
          "<b style='font-size: 500px'>" +
          (
            (value / parseInt(viewobj_json_content.distanceFinale)) *
            100
          ).toPrecision(2) +
          "%</b><br><br><br><b style='font-size: 300px'>",
        suffix: ' ' + units + '</b>',
      },
      gauge: {
        axis: {
          range: [
            0,
            parseInt(viewobj_json_content.distanceFinale) +
              parseInt(viewobj_json_content.margeFinale),
          ],
        },
        steps: [
          ...(viewobj_json_content.gaugeStep !== undefined
            ? viewobj_json_content.gaugeStep
            : []),
        ],
        threshold: {
          line: { color: 'red', width: 4 },
          thickness: 0.75,
          value: parseInt(viewobj_json_content.distanceFinale),
        },
      },
    },
  ];

  const layout = {
    ...viewobj_json_content.layout,
    height: viewobj_json_content.layout.height * ratio,
    width: viewobj_json_content.layout.width * ratio,
  };

  return (
    <BibliothequePlotly
      data={data}
      layout={layout}
      viewobj_json_content={viewobj_json_content}
      modeBar={false}
    />
  );
};

export default ProgresseBar;
